<template>
  <div style="background-color:#f0f5f7">
      <v-app-bar
                 color="#004379"
                 class="login-navbar"
      >
          <v-container>
              <v-row class="align-center justify-space-between">
                  <img class="hns-logo" src="@/assets/img/HNS logo.png" />
                  <span class="text-right white--text font-weight-light text-caption text-sm-body-1">{{todayDate}}</span>
              </v-row>
          </v-container>
      </v-app-bar>
    <v-container class="global-margin">
      <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs pl-0" large></v-breadcrumbs>
      <v-row align="center" justify="center">
        <v-col cols="12" md="8" >

          

          <v-col class="text-center">
            <img width="100%" src="@/assets/img/sumit-matica-mockup.png" />
          </v-col>

          <div class="text-center" id="info">
    
              <v-chip
                  class="ma-2" large=""
                  color="primary"
              >
                    <h3>Osnovne informacije o SUMIT Matici</h3>
              </v-chip>
    
          </div>

         

          <p>
            <b>SUMIT Matica</b> je centralizirani sustav za unos najvažnijih podataka o učenicima i djelatnicima obrazovnih institucija u 
            BiH koje nastavne planove i programe izvode na hrvatskom jeziku.
          </p>
          <p>
            Aplikacija je zamišljena kao digitalni oblik matične knjige koja se u školama ručno ispunjava.<br>
            Na kraju školske godine omogućen je ispis svjedodžbi na temelju unesenih podataka o obrazovanju učenika.
          </p>
          <p>
            Podatke mogu uređivati <b>SUMIT koordinatori i razrednici.</b>
          </p>

          <p>U SUMIT Maticu se unose:</p>
          <ul>
            <li>podatci o učenicima</li>
            <li>podatci o djelatnicima</li>
            <li>podatci o ustanovi.</li>
            
          </ul>

          <p>
              <br>Na temelju podatka koji su u SUMIT Maticu omogućeno je generiranje izvješća o obrazovnim podatcima učenika, izvješća o ustanovi i djelatnicima.
          </p>

          <h2 class="headline pt-5 pb-3">Korisnici SUMIT Matice</h2>

        <v-expansion-panels >
            

            <v-expansion-panel>
                <v-expansion-panel-header style="color: #084776"><h3>Ministarstva obrazovanja, znanosti, kulture i športa</h3></v-expansion-panel-header>
                    <v-expansion-panel-content>
                        Djelatnici ministarstva imaju uvid u sve podatke o učenicima, djelatnicima i ustanovama iz pripadajuće županije.
                    </v-expansion-panel-content>
            </v-expansion-panel>


            <v-expansion-panel>
                <v-expansion-panel-header style="color: #084776"><h3>Zavod za odgoj i obrazovanje i Zavod za školstvo Mostar</h3></v-expansion-panel-header>
                    <v-expansion-panel-content>
                        Uvid u sve podatke iz pripadajućih županija koji su potrebni za obavljanje poslova iz nadležnosti zavoda.
                    </v-expansion-panel-content>
            </v-expansion-panel>


            <v-expansion-panel>
                <v-expansion-panel-header style="color: #084776"><h3>Ravnatelj</h3></v-expansion-panel-header>
                    <v-expansion-panel-content>
                        Ravnatelji imaju pristup svim podacima unutar svoje škole, uvid u izvještaje kao npr. broj učenika i djelatnika u svojoj školi, broj učenika po razrednim
                        odjelima, broj učenika o određenim općim uspjehom itd.
                    </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
                <v-expansion-panel-header style="color: #084776"><h3>SUMIT Koordinatori</h3></v-expansion-panel-header>
                    <v-expansion-panel-content>
                        Kako bi se osigurala kvalitetna komunikacija između SUMIT-a i obrazovnih institucija sve ustanove imenuju SUMIT koordinatora.
                        SUMIT koordinator je službeni predstavnik koji je zadužen za ažuriranje Matice. Preporuka je da SUMIT koordinatora imenuje ravnatelj škole.
                        <br> <br>Obveza SUMIT koordinatora je na početku svake školske godine ažurirati podatke, odnosno dodijeliti elektroničke identitete
                        (eduID) u sustavu autorizacijske i autentifikacijske infrastrukture SUMIT-a.
                        Preporučuje se da SUMIT koordinator bude djelatnik škole koji treba imati uvid u opću sliku djelovanja škole te uvid u stanje i planove upotrebe
                        informacijskih tehnologija škole.
                        <br><br>SUMIT koordinator je dužan poštivati i primjenjivati odluke koje donosi SUMIT ili Županijski koordinatori.
                    </v-expansion-panel-content>
            </v-expansion-panel>

             <v-expansion-panel>
                <v-expansion-panel-header style="color: #084776"><h3>Razrednik</h3></v-expansion-panel-header>
                    <v-expansion-panel-content>
                        Razrednici imaju pristup podacima o učenicima kojima je razrednik, mogućnost preuzimanja podataka o učenicima svoga razreda, pojedinačni ili grupni ispis 
                        svjedodžbi svoga razreda itd.
                    </v-expansion-panel-content>
            </v-expansion-panel>
            
            
        </v-expansion-panels>

      <v-divider style="margin-top:50px"></v-divider>

        <div class="text-center" style="margin-top:50px" id="pomoc">
    
              <v-chip
                  class="ma-2" large=""
                  color="primary"
              >
                    <h3>Trebate pomoć ?</h3>
              </v-chip>
              
    
          </div>



          <h2 class="headline pt-5 pb-3">Prijava u SUMIT Maticu</h2>
          <p>
            SUMIT Matici pristupate uz pomoć mrežnog preglednika upisivanjem mrežne adrese <a style="color: #084776 !important;" href="https://matica.sum.ba" target="_blank">https://matica.sum.ba</a>. 
            Nakon upisivanja mrežne adrese otvara nam se sučelje za prijavu na sustav. <b>Korisnici se prijavljuju pomoću eduID podataka dobivenih u školi (ime.prezime@skole.sum.ba).</b>
          </p>
        </v-col>
        <v-col cols="12" md="7" v-for="(item, i) in upute" :key="i">
          <v-card flat :href="item.link">
            <v-row>
              <v-col cols="10">
                <v-card-title style="color: #084776">{{item.title}}</v-card-title>
                <v-card-subtitle>{{item.text}}</v-card-subtitle>
              </v-col>
              <v-col cols="2">
                <v-card-text>
                  <v-icon class="mt-3" color="#084776">fas fa-chevron-right</v-icon>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        
      </v-row>

        <v-col class="text-center margin-top">
          
          <p><br>
            <b>U slučaju da imate problem sa digitalnim uslugama koje pruža SUMIT kontaktirajte odgovarajuću službu na sljedeći način:</b>
          </p>

             <v-col cols="12" class="text-center margin-top">
            
            <img width="75%" src="@/assets/img/podrska.png/" class="podrska-img">
          
        </v-col>

       </v-col>
      

      <div class="text-center margin-top" id="pitanja">
        
    
              <v-chip
                  class="ma-2" large=""
                  color="primary"
              >
                    <h3 >Često postavljena pitanja</h3>
              </v-chip>   
          </div>
  <v-row align="center" justify="center">
    <v-col cols="12" md="8" >
        <v-expansion-panels v-for="(item, i) in pitanja" :key="i" >

            <v-expansion-panel>
                <v-expansion-panel-header style="color: #084776"><h3>{{item.pitanje}}</h3></v-expansion-panel-header>
                    <v-expansion-panel-content>
                        {{item.odgovor}} 
                        <a v-if="item.link" :href="item.link" target="blank">poveznici.</a>
                    </v-expansion-panel-content>
            </v-expansion-panel>

        </v-expansion-panels>

   
     <div style="margin-top:100px">
       
     </div>                 
            
        

    </v-col>
  </v-row>

     


    </v-container>

  <div  class="footer-info">
    <v-container>
      <v-row class="footer align-center" style="color: rgba(0, 0, 0, 0.6);">
        <a href="https://sumit.sum.ba/" target="_blank">
          <v-hover>
            <v-img
              slot-scope="{ hover }"
              v-if="hover"
              src="@/assets/img/sumit-color.svg"
              class="sum-logo"
              width="305"
            >
            </v-img>
            <v-img
              v-else
              src="@/assets/img/sum-grey.svg"
              class="sum-logo"
              width="305"
            >
            </v-img>
          </v-hover>
        </a>
        
        <span class="copyright font-weight-light" style="margin-left: auto;">SUMIT &copy; 2020</span>
      </v-row>
    </v-container>
  </div>
  </div>



  
</template>

<script>
export default {
  name: "Pomoc",
    created (){
        document.title = "SUMIT matica - O sustavu";
    },
  computed: {
    todayDate() {
      const monthNames = ["siječanj", "veljača", "ožujak", "travanj", "svibanj", "lipanj",
        "srpanj", "kolovoz", "rujan", "listopad", "studeni", "prosinac"];
      let dateObj = new Date();
      let month = monthNames[dateObj.getMonth()];
      let day = String(dateObj.getDate()).padStart(1, '0');
      let year = dateObj.getFullYear();
      let output = `${day}. ${month} ${year}. godine`

      return output
    }
  },
  data() {
    return {
      upute: [
        {
          title: "Pristup usluzi - eduID",
          text: "Kliknite ovdje za pristup usluzi",
          link: "https://matica.sum.ba/"
        },
        
        
      ],

      pitanja:[
           {
             pitanje: '1. Kako se prijaviti u sustav?',
             odgovor: 'U SUMIT Maticu se možete prijaviti koristeći eduID (elektronički identitet). eduID dodjeljuju SUMIT koordinatori u nadležnim ustanovama. Popis svih ustanova sa kontakt podacima možete pronaći na ',
             link:'https://skole.sum.ba/skole'
           },

          {
             pitanje: '2. Tko je SUMIT koordinator moje ustanove?',
             odgovor: 'Popis SUMIT koordinatora i kontakt podatke možete pronaći na',
             link: 'https://skole.sum.ba/kontakt'
           },

        

      ],

      breadcrumbs: [
        {
          text: 'Naslovnica',
          disabled: false,
          to: '/'
        },
        {
          text: 'SUMIT Matica',
          disabled: true,
        },
      ],
    };
  }
};
</script>

<style lang="scss" scoped>
.skolarac {
  margin-top: 150px;
}
@media (max-width: 768px) {
  .skolarac {
    margin-top: 120px !important;
  }
}

@media only screen and (max-width: 600px) {
  .podrska-img{
    width:100%;
  }
  
}

.margin-top{
  margin-top:50px;
}

.v-card__text, .v-card__title {
  word-break: normal;
}

.footer-info{

  background-color: white;
  width: 100%;

}
</style>